import React, { useState } from 'react'
import { TargetTitle } from 'src/components/Global/Text/TitleText'
import { QuicksaveInput } from 'src/components/Global/Input/Input'
import { ModalButton } from 'src/components/Global/Button/Button'
import { useLocation, useParams } from 'react-router-dom'

import { CreateTargetWrapper, FormContainer } from './createTargetStyle'
import { DatePicker } from 'src/components/Global/Date/Date'
import { BankSettingsSelectInput } from 'src/components/Global/SelectBox/Select'
import { SelectFrequency } from 'src/components/Global/SelectBox/SelectData'
import { useDispatch } from 'react-redux'
import { acceptCollaboInvitetAction } from 'src/redux/actions/collaboAction'
const AcceptCollabo = () => {
  const params = useParams()
  const { id } = params
  const [automatedChecked, setautomatedChecked] = useState(false)
  const [manualChecked, setmanualChecked] = useState(true)
  const [planData, setPlanData] = useState({
    start_date: '',
    saving_type: '',
    amount_to_save: '',
    saving_frequency: '',
    device: 'mobile',
    main_card: 'new',
    id: id,
  })
  const { start_date, saving_type, saving_frequency, amount_to_save } = planData
  const handleChange = (e: any) => {
    const { name, value } = e.target
    const newData: any = { ...planData }
    newData[name] = value
    setPlanData(newData)
    console.log(planData)
  }
  const dispatch = useDispatch()

  const handleautomatedOnChange = () => {
    setautomatedChecked(!automatedChecked)
    setmanualChecked(!manualChecked)
  }

  const handleManualOnChange = () => {
    setmanualChecked(!manualChecked)
    setautomatedChecked(!automatedChecked)
  }

  const handleSubmit = (e: any) => {
    e.preventDefault()
    if (manualChecked) {
      planData.saving_type = 'manual'
      planData.saving_frequency = 'weekly'
    }
    if (automatedChecked) {
      planData.saving_type = 'automated'
    }
    if (!start_date || !saving_type) {
    }
    const payload = {
      collabo: {
        ...planData,
      },
    }
    dispatch(acceptCollaboInvitetAction(payload))
    console.log(planData)
  }
  const Disabled = () => {
    if (!start_date) {
      return 'blur'
    }
    return null
  }
  return (
    <FormContainer>
      <CreateTargetWrapper onSubmit={handleSubmit}>
        <TargetTitle className="targetTitle">Accept Collabo Invite</TargetTitle>
        <div className="input-two">
          <h4>When do you want to start?</h4>
          <DatePicker
            type="date"
            value={start_date}
            onChange={handleChange}
            name="start_date"
            placeholder="Start Date"
          />
        </div>
        <div className="destination">
          <h4>Saving Frequency</h4>
          <div className="">
            <label className="container">
              Manually
              <input
                type="radio"
                checked={manualChecked}
                name="saving_type"
                value={saving_type}
                onChange={handleManualOnChange}
              />
              <span className="checkmark"></span>
            </label>
            <label className="container">
              Automated
              <input
                type="radio"
                checked={automatedChecked}
                name="saving_type"
                value="saving_type"
                onChange={handleautomatedOnChange}
              />
              <span className="checkmark"></span>
            </label>
            {automatedChecked && (
              <div className="details-amount">
                <div className="amount">
                  <h6>Auto debit amount</h6>
                  <QuicksaveInput
                    className="amount-pad"
                    type="number"
                    name="amount_to_save"
                    placeholder="1000"
                    value={amount_to_save}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group-select">
                  <h6>Frequency</h6>
                  <BankSettingsSelectInput
                    className="amount-pad"
                    name="saving_frequency"
                    value={saving_frequency}
                    onChange={handleChange}
                  >
                    {SelectFrequency.map(({ id, option }) => {
                      return <option key={id}>{option}</option>
                    })}
                  </BankSettingsSelectInput>
                </div>
              </div>
            )}
          </div>
        </div>
        <ModalButton className={`target ${Disabled()}`}>
          Accept Invite
        </ModalButton>
      </CreateTargetWrapper>
    </FormContainer>
  )
}

export { AcceptCollabo }
